const Data = {
  selectDocument: () => ({
    type: "select",
    name: "pessoa",
    label: "Tipo de Pessoa",
    mask: "",
    value: "",
    placeholder: "",
    regex_filter: "",
    select_options: [
      {
        label: "Todos os Tipos",
        value: "all",
      },
      {
        label: "Pessoa Física",
        value: "cpf",
      },
      {
        label: "Pessoa Juridica",
        value: "cnpj",
      },
    ],
    info: {
      description: "tipo de pessoa",
    },
  }),
  selectTypeOfQuery: (props) => ({
    id: "select2",
    type: "select",
    name: "consulta",
    label: "Tipo de Consulta",
    placeholder: "",
    mask: "",
    value: "",
    regex_filter: "",
    select_options: props.modelos.reduce((result, e) => {
      if (props.document == "all" || props.document == e.tipo_documento) {
        result.push({ label: e.nome_consulta, value: e.id });
      }
      return result;
    }, []),

    info: {
      description: "tipo de consulta",
    },
  }),
};

export default Data;
